const NAME = "ASSETS_DISCOUNTS_ENTRY_BY_IMPORT";

export default NAME;
